import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core'
import { Observable } from 'rxjs'
import { DealContractPdfQuery } from 'generated/graphql'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'

@UntilDestroy()
@Component({
    selector: 'mg-contract-pdf',
    templateUrl: './contract-pdf.component.html',
    styleUrls: ['./contract-pdf.component.scss'],
})
export class ContractPdfComponent implements OnInit {
    isLoading: boolean = true

    @Input()
    dealContractPdf$: Observable<DealContractPdfQuery['DealContractPdf']>

    @Input()
    proceedButtonText: string = ''

    @Input()
    downloadButtonText: string = ''

    @Input()
    viewButtonText: string = ''

    @Output()
    proceedButtonClick = new EventEmitter()

    constructor() {}

    ngOnInit() {
        this.dealContractPdf$.pipe(untilDestroyed(this)).subscribe(pdfObject => {
            if (pdfObject && pdfObject.url) {
                this.isLoading = false
            }
        })
    }

    handleProceedButtonClick() {
        this.proceedButtonClick.emit()
    }
}
